module.exports = __webpack_public_path__ + "assets/group-med_specialistams.48d36b53.svg";